import template from 'text!./templates/pa-address-change-edit.html';

export default [function () {
    return {
        template: template,
        'restrict': 'E',
        'scope': {
            policyChange: '=',
            view: '=',
            next: '&'
        },
        'controller': ['$scope', 'ModalService', function ($scope) {
            $scope.policyChange.lobData.personalAuto.coverables.updateGarageLocation = true;

            /**
             * Next button is clicked
             */
            $scope.onNext = function () {
                // Call next method on parent
                $scope.next();
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/endorsement/pa/directives/PAAddressChangeEdit.js
// module id = 1465
// module chunks = 0